import { render } from "./Program.vue?vue&type=template&id=ad415ab6"
import script from "./Program.vue?vue&type=script&lang=js"
export * from "./Program.vue?vue&type=script&lang=js"
script.render = render

export default script